import { gql } from '@apollo/client'

export const SUB_ACTION_FRAGMENT = gql`
  fragment SubAction on Action {
    title
    description
    dueDate
    dueDateTime
    actionType
    id
    status
    createdBy {
      id
      firstName
      lastName
      email
    }
    actionGenerator {
      id
      repeatSchedule
      endDate
    }
    store {
      id
      location {
        id
        name
        address1
        city
        state
        postalCode
      }
    }
    notes {
      id
      note
      createdTime
      createdBy {
        id
        firstName
        lastName
        email
      }
    }
    closedBy {
      id
    }
    actionGroup {
      id
      title
    }
    actionShift {
      id
      title
    }
    completions {
      id
      startTime
      endTime
      images {
        id
        url
      }
      completedBy {
        id
        firstName
        lastName
        email
      }
    }
    parentAction {
      id
      title
    }
    aiImageCheck
    notifyOnFailure
    notifyOnSuccess
    notifyActiveManager
    peopleToNotify {
      id
      firstName
      lastName
      email
    }
  }
`
